(function () {
  'use strict';

  var ready = function (fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  function initTabs(root) {
    if (root.dataset.pfTabsReady === '1') return;
    root.dataset.pfTabsReady = '1';

    var pills = Array.prototype.slice.call(root.querySelectorAll('[data-pf-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-pf-panel]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pf-thumb]'));

    function select(key) {
      pills.forEach(function (pill) {
        pill.setAttribute('aria-selected', String(pill.dataset.pfTab === key));
      });
      thumbs.forEach(function (thumb) {
        thumb.setAttribute('aria-selected', String(thumb.dataset.pfThumb === key));
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.dataset.pfPanel !== key;
      });
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        select(pill.dataset.pfTab);
      });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        select(thumb.dataset.pfThumb);
      });
    });
  }

  function initCompare(frame) {
    if (frame.dataset.pfCompareReady === '1') return;
    frame.dataset.pfCompareReady = '1';

    var dragging = false;
    var vertical = false;
    var grip = frame.querySelector('[data-pf-compare-grip]');

    function readAxis() {
      var axis = getComputedStyle(frame).getPropertyValue('--pf-compare-axis');
      return axis.trim() === 'y';
    }

    function setFromPoint(point) {
      var box = frame.getBoundingClientRect();
      var pct;
      if (vertical) {
        if (!box.height) return;
        pct = ((point.clientY - box.top) / box.height) * 100;
      } else {
        if (!box.width) return;
        pct = ((point.clientX - box.left) / box.width) * 100;
      }
      pct = Math.max(0, Math.min(100, pct));
      frame.style.setProperty('--pf-compare-pos', pct + '%');
    }

    function start(event) {
      vertical = readAxis();
      if (vertical && grip && !grip.contains(event.target)) return;
      dragging = true;
      setFromPoint(event.touches ? event.touches[0] : event);
      if (!event.touches) event.preventDefault();
    }

    function move(event) {
      if (!dragging) return;
      setFromPoint(event.touches ? event.touches[0] : event);
    }

    function end() {
      dragging = false;
    }

    frame.addEventListener('mousedown', start);
    frame.addEventListener('touchstart', start, { passive: true });
    window.addEventListener('mousemove', move);
    window.addEventListener('touchmove', move, { passive: true });
    window.addEventListener('mouseup', end);
    window.addEventListener('touchend', end);

    frame.addEventListener('mousemove', function (event) {
      if (dragging) return;
      if (frame.dataset.pfCompareHover !== 'true') return;
      vertical = readAxis();
      setFromPoint(event);
    });
  }

  function initBanner(frame) {
    if (frame.dataset.pfBannerReady === '1') return;
    frame.dataset.pfBannerReady = '1';

    var button = frame.querySelector('[data-pf-play]');
    var video = frame.querySelector('video');
    if (!button) return;

    button.addEventListener('click', function () {
      frame.classList.add('is-playing');
      if (video) {
        video.controls = true;
        video.play();
        return;
      }
      var src = frame.dataset.pfEmbed;
      if (!src) return;
      var iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.setAttribute('title', frame.dataset.pfEmbedTitle || 'Product video');
      frame.appendChild(iframe);
    });
  }

  function initGallery(root) {
    if (root.dataset.pfGalleryReady === '1') return;
    root.dataset.pfGalleryReady = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pf-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pf-gthumb]'));
    var counter = root.querySelector('[data-pf-counter]');
    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-pf-filter]'));
    var thumbStrip = root.querySelector('[data-pf-thumbs]');
    var thumbTrack = root.querySelector('[data-pf-thumb-track]');
    var thumbPrev = root.querySelector('[data-pf-thumb-prev]');
    var thumbNext = root.querySelector('[data-pf-thumb-next]');
    var index = 0;
    var filter = 'image';

    function visible() {
      return slides.filter(function (slide) {
        return filter === 'all' || slide.dataset.pfKind === filter;
      });
    }

    function syncPlaying() {
      var active = slides.filter(function (slide) {
        return !slide.hidden;
      })[0];
      var video = active ? active.querySelector('video') : null;
      root.classList.toggle('is-playing', !!video && !video.paused && !video.ended);
    }

    function syncThumbArrows() {
      if (!thumbTrack) return;
      var max = thumbTrack.scrollWidth - thumbTrack.clientWidth;
      var scrollable = max > 1;
      if (thumbStrip) thumbStrip.classList.toggle('is-scrollable', scrollable);
      if (thumbPrev) thumbPrev.hidden = !scrollable || thumbTrack.scrollLeft <= 1;
      if (thumbNext) thumbNext.hidden = !scrollable || thumbTrack.scrollLeft >= max - 1;
    }

    function scrollThumbs(direction) {
      if (!thumbTrack) return;
      var step = Math.max(thumbTrack.clientWidth * 0.8, 120);
      thumbTrack.scrollLeft += direction * step;
    }

    function revealThumb(thumb) {
      if (!thumbTrack || !thumb || thumb.hidden) return;
      var left = thumb.offsetLeft - (thumbPrev ? thumbPrev.offsetWidth : 0);
      var right = thumb.offsetLeft + thumb.offsetWidth + (thumbNext ? thumbNext.offsetWidth : 0);
      if (left < thumbTrack.scrollLeft) {
        thumbTrack.scrollLeft = Math.max(left, 0);
      } else if (right > thumbTrack.scrollLeft + thumbTrack.clientWidth) {
        thumbTrack.scrollLeft = right - thumbTrack.clientWidth;
      }
    }

    function render() {
      var list = visible();
      if (!list.length) list = slides;
      if (index >= list.length) index = 0;
      if (index < 0) index = list.length - 1;

      slides.forEach(function (slide) {
        slide.hidden = slide !== list[index];
        if (slide.hidden) {
          var video = slide.querySelector('video');
          if (video && !video.paused) video.pause();
        }
      });
      var current = null;
      thumbs.forEach(function (thumb) {
        var slide = slides[Number(thumb.dataset.pfGthumb)];
        thumb.hidden = list.indexOf(slide) === -1;
        thumb.setAttribute('aria-selected', String(slide === list[index]));
        if (slide === list[index]) current = thumb;
      });
      if (counter) counter.textContent = index + 1 + ' / ' + list.length;
      root.classList.toggle('is-video', filter === 'video');
      syncPlaying();
      syncThumbArrows();
      revealThumb(current);
    }

    slides.forEach(function (slide) {
      var video = slide.querySelector('video');
      if (!video) return;
      ['play', 'playing', 'pause', 'ended'].forEach(function (name) {
        video.addEventListener(name, syncPlaying);
      });
    });

    if (thumbTrack) {
      thumbTrack.addEventListener('scroll', syncThumbArrows, { passive: true });
      window.addEventListener('resize', syncThumbArrows);
      if (window.ResizeObserver) new ResizeObserver(syncThumbArrows).observe(thumbTrack);
    }

    if (thumbPrev) {
      thumbPrev.addEventListener('click', function () {
        scrollThumbs(-1);
      });
    }

    if (thumbNext) {
      thumbNext.addEventListener('click', function () {
        scrollThumbs(1);
      });
    }

    root.querySelectorAll('[data-pf-prev]').forEach(function (button) {
      button.addEventListener('click', function () {
        index -= 1;
        render();
      });
    });

    root.querySelectorAll('[data-pf-next]').forEach(function (button) {
      button.addEventListener('click', function () {
        index += 1;
        render();
      });
    });

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var slide = slides[Number(thumb.dataset.pfGthumb)];
        var list = visible();
        var at = list.indexOf(slide);
        if (at === -1) {
          filter = slide.dataset.pfKind;
          filters.forEach(function (item) {
            item.setAttribute('aria-pressed', String(item.dataset.pfFilter === filter));
          });
          list = visible();
          at = list.indexOf(slide);
        }
        index = at;
        render();
      });
    });

    var stage = root.querySelector('.pf-buy__stage');
    if (stage) {
      var startX = 0;
      var startY = 0;
      var tracking = false;

      stage.addEventListener(
        'touchstart',
        function (event) {
          if (event.touches.length !== 1 || visible().length < 2) return;
          tracking = true;
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
        },
        { passive: true }
      );

      stage.addEventListener(
        'touchend',
        function (event) {
          if (!tracking) return;
          tracking = false;
          var touch = event.changedTouches[0];
          var dx = touch.clientX - startX;
          var dy = touch.clientY - startY;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
          index += dx < 0 ? 1 : -1;
          render();
        },
        { passive: true }
      );

      stage.addEventListener('touchcancel', function () {
        tracking = false;
      });
    }

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        filter = button.dataset.pfFilter;
        index = 0;
        filters.forEach(function (item) {
          item.setAttribute('aria-pressed', String(item === button));
        });
        render();
      });
    });

    render();
  }

  function initRisks(root) {
    if (root.dataset.pfRisksReady === '1') return;
    root.dataset.pfRisksReady = '1';

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-pf-risk]'));
    if (items.length < 2) return;

    var row = root.querySelector('[data-pf-risks-row]');
    var index = 0;

    items.forEach(function (item, at) {
      if (item.classList.contains('pf-risks__item--open')) index = at;
    });

    function render(move) {
      items.forEach(function (item, at) {
        var open = at === index;
        item.classList.toggle('pf-risks__item--open', open);
        item.setAttribute('aria-expanded', String(open));
      });

      if (!move || !row || row.scrollWidth - row.clientWidth < 2) return;
      var target = items[index].getBoundingClientRect();
      var box = row.getBoundingClientRect();
      row.scrollBy({
        left: target.left - box.left - (box.width - target.width) / 2,
        behavior: 'smooth'
      });
    }

    function step(delta) {
      index = (index + delta + items.length) % items.length;
      render(true);
    }

    items.forEach(function (item, at) {
      item.addEventListener('click', function () {
        if (at === index) return;
        index = at;
        render(true);
      });
    });

    root.querySelectorAll('[data-pf-risk-prev]').forEach(function (button) {
      button.addEventListener('click', function () {
        step(-1);
      });
    });

    root.querySelectorAll('[data-pf-risk-next]').forEach(function (button) {
      button.addEventListener('click', function () {
        step(1);
      });
    });

    root.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      step(event.key === 'ArrowLeft' ? -1 : 1);
    });

    render(false);
  }

  function initQuantity(root) {
    if (root.dataset.pfQtyReady === '1') return;
    root.dataset.pfQtyReady = '1';

    var input = root.querySelector('[data-pf-qty-input]');
    if (!input) return;

    root.querySelectorAll('[data-pf-qty-step]').forEach(function (button) {
      button.addEventListener('click', function () {
        var step = Number(button.dataset.pfQtyStep);
        var min = Number(input.min || 1);
        var next = Math.max(min, (Number(input.value) || min) + step);
        input.value = String(next);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function initCopy(root) {
    if (root.dataset.pfCopyReady === '1') return;
    root.dataset.pfCopyReady = '1';

    root.querySelectorAll('[data-pf-copy]').forEach(function (button) {
      button.addEventListener('click', function () {
        var code = button.dataset.pfCopy;
        if (!code) return;
        var done = function () {
          var label = button.querySelector('[data-pf-copy-label]') || button;
          var original = label.textContent;
          label.textContent = button.dataset.pfCopyDone || 'Copied';
          setTimeout(function () {
            label.textContent = original;
          }, 1600);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, done);
        } else {
          var field = document.createElement('textarea');
          field.value = code;
          document.body.appendChild(field);
          field.select();
          try { document.execCommand('copy'); } catch (error) { }
          document.body.removeChild(field);
          done();
        }
      });
    });
  }

  function initCheckoutSize(root) {
    if (root.dataset.pfCheckoutSizeReady === '1') return;
    root.dataset.pfCheckoutSizeReady = '1';

    root.querySelectorAll('[data-pf-checkout]').forEach(function (box) {
      var peer = root.querySelector(box.dataset.pfCheckout);
      if (!peer) return;

      function measure() {
        return box.querySelector('shopify-accelerated-checkout')
          || box.querySelector('.shopify-payment-button__button')
          || box.firstElementChild
          || box;
      }

      function apply() {
        var height = Math.round(measure().getBoundingClientRect().height);
        if (height >= 30) peer.style.height = height + 'px';
      }

      apply();
      window.addEventListener('load', apply);
      [300, 1000, 2500].forEach(function (wait) {
        setTimeout(apply, wait);
      });
      if (typeof ResizeObserver === 'function') new ResizeObserver(apply).observe(box);
      if (typeof MutationObserver === 'function') {
        new MutationObserver(apply).observe(box, { childList: true, subtree: true });
      }
    });
  }

  function initBuyNow(root) {
    if (root.dataset.pfBuyNowReady === '1') return;
    root.dataset.pfBuyNowReady = '1';

    var buyButtons = Array.prototype.slice.call(root.querySelectorAll('[data-pf-buy-checkout]'));
    if (!buyButtons.length) return;

    function leaving() {
      return root.dataset.pfCheckout === '1';
    }

    function muteDrawer() {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || drawer.pfBuyNowPatched || typeof drawer.show !== 'function') return;
      var show = drawer.show;
      drawer.pfBuyNowPatched = true;
      drawer.show = function () {
        if (leaving()) return;
        return show.apply(this, arguments);
      };
    }

    root.querySelectorAll('[type="submit"]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (buyButtons.indexOf(button) === -1) {
          delete root.dataset.pfCheckout;
          return;
        }
        root.dataset.pfCheckout = '1';
        muteDrawer();
      });
    });

    document.addEventListener('ajaxProduct:added', function () {
      if (!leaving()) return;
      var root_url = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
      window.location.href = (root_url || '/') + 'checkout';
      setTimeout(function () {
        delete root.dataset.pfCheckout;
      }, 3000);
    });

    document.addEventListener('ajaxProduct:error', function () {
      delete root.dataset.pfCheckout;
    });
  }

  function initVariantCards(root) {
    if (root.dataset.pfVariantReady === '1') return;
    root.dataset.pfVariantReady = '1';

    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-pf-variant]'));
    if (!inputs.length) return;

    var idField = root.querySelector('[data-pf-variant-id]');
    var priceField = root.querySelector('[data-pf-price]');
    var compareField = root.querySelector('[data-pf-compare-price]');
    var submit = root.querySelector('[data-pf-submit]');

    function apply(input) {
      if (idField && idField.value !== input.value) {
        idField.value = input.value;
        idField.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (priceField && input.dataset.pfPrice) priceField.textContent = input.dataset.pfPrice;
      if (compareField) {
        compareField.textContent = input.dataset.pfComparePrice || '';
        compareField.hidden = !input.dataset.pfComparePrice;
      }
      if (submit) {
        var available = input.dataset.pfAvailable === 'true';
        submit.disabled = !available;
        submit.textContent = available
          ? submit.dataset.pfLabel || 'Add to cart'
          : submit.dataset.pfSoldOut || 'Sold out';
      }
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (input.checked) apply(input);
      });
      if (input.checked) apply(input);
    });
  }

  function initAccessories(root) {
    if (root.dataset.pfAccessoryReady === '1') return;
    root.dataset.pfAccessoryReady = '1';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-pf-accessory]'));
    if (!cards.length) return;

    cards.forEach(function (card) {
      var box = card.querySelector('[data-pf-accessory-input]');
      if (!box) return;

      function sync() {
        card.classList.toggle('is-selected', box.checked);
      }

      box.checked = false;
      sync();
      box.addEventListener('change', sync);
    });
  }

  function initStickyBar(root) {
    if (root.dataset.pfBarReady === '1') return;
    root.dataset.pfBarReady = '1';

    var bar = root.querySelector('[data-pf-bar]');
    if (!bar) return;

    var form = root.querySelector('.pf-buy__form');
    var submit = root.querySelector('[data-pf-submit]');
    var formQty = form ? form.querySelector('[data-pf-qty-input]') : null;
    var barQty = bar.querySelector('[data-pf-bar-qty]');
    var barPrice = bar.querySelector('[data-pf-bar-price]');
    var barSave = bar.querySelector('[data-pf-bar-save]');
    var barCompare = bar.querySelector('[data-pf-bar-compare]');
    var barAdd = bar.querySelector('[data-pf-bar-add]');
    var barBuy = bar.querySelector('[data-pf-bar-buy]');
    var buyNow = root.querySelector('[data-pf-buy-checkout]');
    var pending = false;

    function renderBarPrice(el, text) {
      var str = String(text == null ? '' : text);
      var parts = str.match(/^(.*)\.(\d+)$/);
      while (el.firstChild) el.removeChild(el.firstChild);
      if (!parts) {
        el.textContent = str;
        return;
      }
      [
        ['pf-buy__bar-now-main', parts[1]],
        ['pf-buy__bar-now-dot', '.'],
        ['pf-buy__bar-now-frac', parts[2]]
      ].forEach(function (pair) {
        var span = document.createElement('span');
        span.className = pair[0];
        span.textContent = pair[1];
        el.appendChild(span);
      });
    }
    var release = null;

    function reveal() {
      if (bar.hidden) {
        bar.hidden = false;
        void bar.offsetHeight;
      }
      bar.classList.add('is-visible');
    }

    function clearPending() {
      pending = false;
      if (release) {
        clearTimeout(release);
        release = null;
      }
    }

    function markPending() {
      pending = true;
      if (release) clearTimeout(release);
      release = setTimeout(clearPending, 10000);
    }

    if (form) {
      form.addEventListener('submit', markPending, true);
    }

    var trigger = bar.dataset.pfBarTrigger === 'cart' ? 'cart' : 'always';

    document.addEventListener('ajaxProduct:added', function () {
      if (root.dataset.pfCheckout === '1') return;
      if (pending) reveal();
    });

    document.addEventListener('ajaxProduct:error', clearPending);

    if (trigger === 'always') {
      reveal();

      var reserve = function () {
        var height = bar.offsetHeight;
        if (height > 0) {
          document.documentElement.style.setProperty('--pf-bar-h', height + 'px');
        }
      };

      document.body.classList.add('pf-bar-on');
      reserve();
      window.addEventListener('load', reserve);
      window.addEventListener('resize', reserve);
      if (typeof ResizeObserver === 'function') new ResizeObserver(reserve).observe(bar);
    }

    if (barQty && formQty) {
      barQty.addEventListener('change', function () {
        formQty.value = barQty.value;
      });
      formQty.addEventListener('change', function () {
        barQty.value = formQty.value;
      });
    }

    function syncQty() {
      if (formQty && barQty) formQty.value = barQty.value;
    }

    [barAdd, barBuy].forEach(function (button) {
      if (button) button.addEventListener('click', syncQty);
    });

    var idField = root.querySelector('[data-pf-variant-id]');
    var barFormId = bar.querySelector('[data-pf-bar-variant-id]');
    var barFormQty = bar.querySelector('[data-pf-bar-form-qty]');

    if (barFormId || barFormQty) {
      var syncBarForm = function () {
        if (barFormId && idField) barFormId.value = idField.value;
        var qty = barQty || formQty;
        if (barFormQty && qty) barFormQty.value = qty.value;
      };

      if (idField) idField.addEventListener('change', syncBarForm);
      if (barQty) barQty.addEventListener('change', syncBarForm);
      if (formQty) formQty.addEventListener('change', syncBarForm);
      syncBarForm();
    }

    root.querySelectorAll('[data-pf-variant]').forEach(function (input) {
      function apply() {
        if (!input.checked) return;
        if (barPrice && input.dataset.pfPrice) renderBarPrice(barPrice, input.dataset.pfPrice);
        if (barSave) {
          barSave.textContent = input.dataset.pfSave || '';
          barSave.hidden = !input.dataset.pfSave;
        }
        if (barCompare) {
          barCompare.textContent = input.dataset.pfComparePrice || '';
          barCompare.hidden = !input.dataset.pfComparePrice;
        }
        if (barAdd && submit) {
          barAdd.disabled = submit.disabled;
          barAdd.textContent = submit.textContent;
        }
        if (barBuy && buyNow) barBuy.disabled = buyNow.disabled;
      }
      input.addEventListener('change', apply);
      apply();
    });
  }

  function initReveal(root) {
    if (root.dataset.pfRevealReady === '1') return;
    root.dataset.pfRevealReady = '1';

    var section = root.closest('.pf-figure');
    var pin = root.querySelector('.pf-figure__pin');
    var media = root.querySelector('.pf-figure__media');
    var img = media && media.querySelector('img');
    if (!section || !pin || !img) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var allowMobile = root.dataset.pfRevealMobile !== 'false';
    var endRadius = parseFloat(root.dataset.pfRevealRadius);
    if (isNaN(endRadius)) endRadius = 20;
    var startPct = parseFloat(root.dataset.pfRevealStart) || 26;
    var midPct = parseFloat(root.dataset.pfRevealMid) || 62;
    var degree = section.querySelector('[data-pf-degree]');
    var steps = degree ? degree.querySelectorAll('.pf-figure__degree-step') : [];
    var arc = section.querySelector('.pf-figure__degree-arc');
    var step = -1;
    var active = false;
    var queued = false;

    function setStep(next) {
      if (next === step) return;
      step = next;
      for (var i = 0; i < steps.length; i += 1) {
        steps[i].classList.toggle('is-on', i === next);
      }
      if (arc) arc.classList.toggle('is-on', next === steps.length - 1);
    }

    function usable() {
      if (reduce.matches) return false;
      if (window.innerWidth < 750 && !allowMobile) return false;
      return true;
    }

    function lerp(a, b, t) {
      return a + (b - a) * t;
    }

    function paint() {
      queued = false;
      if (!active) return;

      var span = root.offsetHeight - window.innerHeight;
      var p = span > 0 ? -root.getBoundingClientRect().top / span : 0;
      p = Math.max(0, Math.min(1, p));

      var rx;
      var ry;

      if (window.innerWidth < 750) {
        var wide = img.clientWidth || media.clientWidth;
        var high = img.clientHeight;
        if (!wide || !high) return;
        section.style.removeProperty('--pf-rv-clip');
        section.style.setProperty('--pf-rv-rx', lerp(50, (endRadius * 100) / wide, p).toFixed(3) + '%');
        section.style.setProperty('--pf-rv-ry', lerp(50, (endRadius * 100) / high, p).toFixed(3) + '%');
      } else {
        var box = img.clientWidth || root.clientWidth || media.clientWidth;
        var ratio = img.naturalWidth && img.naturalHeight ? img.naturalHeight / img.naturalWidth : 0.475;
        var tall = img.clientHeight || box * ratio;
        if (!box || !tall) return;

        var dot = Math.min((tall * startPct) / 100, box);
        var oval = Math.max(dot, (box * midPct) / 100);
        var pane;
        var edge;

        if (p <= 0.5) {
          pane = lerp(dot, oval, p / 0.5);
          edge = Math.min(pane, tall) / 2;
        } else {
          var t = (p - 0.5) / 0.5;
          pane = lerp(oval, box, t);
          edge = lerp(Math.min(oval, tall) / 2, endRadius, t);
        }

        rx = edge;
        ry = edge;

        section.style.setProperty('--pf-rv-rx', '0px');
        section.style.setProperty('--pf-rv-ry', '0px');
        section.style.setProperty(
          '--pf-rv-clip',
          'inset(0px ' + ((box - pane) / 2).toFixed(2) + 'px round ' + rx.toFixed(2) + 'px / ' + ry.toFixed(2) + 'px)'
        );
      }

      if (steps.length) {
        var last = steps.length - 1;
        setStep(last === 0 ? 0 : Math.min(last, Math.floor(p * (last + 1))));
      }
    }

    function schedule() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(paint);
    }

    function sync() {
      var next = usable();
      if (next !== active) {
        active = next;
        section.classList.toggle('is-pf-reveal', active);
        if (degree) degree.classList.toggle('is-pf-stepped', active && steps.length > 0);
        if (!active) {
          setStep(steps.length - 1);
          ['--pf-rv-rx', '--pf-rv-ry', '--pf-rv-clip'].forEach(function (name) {
            section.style.removeProperty(name);
          });
        }
      }
      if (active) paint();
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', sync);
    if (typeof reduce.addEventListener === 'function') reduce.addEventListener('change', sync);
    if (!img.complete) img.addEventListener('load', sync);
    window.addEventListener('load', sync);
    if (typeof ResizeObserver === 'function') new ResizeObserver(sync).observe(root);
    sync();
  }

  function boot(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-pf-tabs]').forEach(initTabs);
    context.querySelectorAll('[data-pf-compare]').forEach(initCompare);
    context.querySelectorAll('[data-pf-reveal]').forEach(initReveal);
    context.querySelectorAll('[data-pf-banner]').forEach(initBanner);
    context.querySelectorAll('[data-pf-gallery]').forEach(initGallery);
    context.querySelectorAll('[data-pf-risks]').forEach(initRisks);
    context.querySelectorAll('[data-pf-qty]').forEach(initQuantity);
    context.querySelectorAll('[data-pf-buybox]').forEach(function (root) {
      initCopy(root);
      initVariantCards(root);
      initAccessories(root);
      initCheckoutSize(root);
      initBuyNow(root);
      initStickyBar(root);
    });
  }

  ready(function () {
    boot(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
